module.exports = __webpack_public_path__ + "img/login-rs2.e360286b.png";